angular.module('eStories.notifications', [
    'eStories.carousel.service',
    'eStories.account.model'
    /*Notification Module*/

])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.notifications', {
                url: '^eStories.navbars',
                views: {
                    'notifications@': {
                        templateUrl: 'notifications/notifications.tmpl.html',
                        controller: 'NotificationsCtrl as notificationsCtrl'
                    }
                }
            });
    }])

    .controller('NotificationsCtrl', ['$state', 'CarouselService', '$timeout', 'AccountModel',
        function ($state, CarouselService, $timeout, AccountModel) {

            let notificationsCtrl = this;

            /*State check*/
            notificationsCtrl.isHomePage = function () {
                return $state.is('eStories.navbars')
            };

            notificationsCtrl.account = AccountModel;

            notificationsCtrl.collapseNotificationBanner = false;

            notificationsCtrl.currentIndex = 0;

            /*Mock up carousel data*/
            notificationsCtrl.homeNotifications = [
                'Call to Action Message - Sign Up Today for FREE, get your first book on us!',
                '------11111------',
                '------22222------',
                '------33333------',
                '------44444------',
                '------55555------'
            ];

            notificationsCtrl.getNote = function (index, direction) {
                var indexes = CarouselService.setIndexes(index, notificationsCtrl.homeNotifications.length);

                /*Setting indexes on scope controller*/
                notificationsCtrl.currentIndex = indexes.currentIndex;
                notificationsCtrl.nextIndex = indexes.nextIndex;
                notificationsCtrl.previousIndex = indexes.previousIndex;

            };

            /*Init Carousel with index 0*/
            notificationsCtrl.getNote(notificationsCtrl.currentIndex);


            /* Triggers */
            //This will be $on event listeners that will trigger the various notifications

        }]);
    

